import { NgModule } from '@angular/core';
import { ProjectCardDataComponent } from '../project-card-data/project-card-data.component';
import { CommonModule } from '@angular/common';
import {
  OpsFiscalYearComponent,
  OpsProjectStatusComponent,
} from '@ops/storybook';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  imports: [
    CommonModule,
    OpsProjectStatusComponent,
    OpsFiscalYearComponent,
    TranslateModule,
  ],
  exports: [ProjectCardDataComponent],
  declarations: [ProjectCardDataComponent],
})
export class ProjectCardDataModule {}
